module.exports = __webpack_public_path__ + "img/logo.02d99411.svg";